var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrainingIcon = function SvgTrainingIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1994_1",
    "data-name": "Component 1994 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 18,
    viewBox: "0 0 16.2 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M14.25,12.25c0,1.8-2.25,3.15-2.25,4.5H10.2c0-1.35-2.25-2.7-2.25-4.5A3.153,3.153,0,0,1,11.1,9.1h0A3.153,3.153,0,0,1,14.25,12.25ZM12,17.65H10.2V19H12Zm5.4-5.85a6.244,6.244,0,0,1-1.422,3.978l1.278,1.278a8.081,8.081,0,0,0-.9-11.412L15.078,6.922A6.294,6.294,0,0,1,17.4,11.8ZM14.7,4.6,11.1,1V3.7h0A8.268,8.268,0,0,0,5.813,5.663,7.929,7.929,0,0,0,3,11.8a8.077,8.077,0,0,0,1.944,5.256l1.278-1.278A6.244,6.244,0,0,1,4.8,11.8a6.307,6.307,0,0,1,6.3-6.3h0V8.2Z",
    transform: "translate(-3 -1)",
    fill: "#205171"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrainingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/training-icon.e17b0d5a39b42d8f84b7d8f4c58fdd8f.svg";